import React from 'react';
import { mainBanner } from '@features/homepage';
import Image from 'next/image';

const MainBanner = () => {
  return (
    <div className="relative flex h-[15rem] w-[120rem] flex-col items-center justify-center gap-[1rem] px-[12rem]">
      <Image src={mainBanner} alt={'Main Banner image'} fill />
    </div>
  );
};

export default MainBanner;
